// Note: The first file of a module here, must also register the module

import "./house-occupant-form.component";
import "./house-occupant-list.component";
import "./house-occupant.component";
import "./house-occupants-view.component";
import "./view-house-occupant.component";
